import { createSelector } from "reselect";

const selectAudio = (state) => state.audio;

export const selectAllAudio = createSelector(
  [selectAudio],
  (audio) => audio.allAudio
);

export const selectSingleAudio = createSelector(
  [selectAudio],
  (audio) => audio.singleAudio
);

export const selectAllAudioLoading = createSelector(
  [selectAudio],
  (audio) => audio.isLoadingAllAudio
);

export const selectSingleAudioLoading = createSelector(
  [selectAudio],
  (audio) => audio.isLoadingSingleAudio
);

export const selectIsCreatingAudio = createSelector(
  [selectAudio],
  (audio) => audio.isCreatingAudio
);

export const selectCurrentaudio = createSelector(
  [selectAudio],
  (audio) => audio.singleAudio
);

export const selectIsDeletingAudio = createSelector(
  [selectAudio],
  (audio) => audio.isDeletingAudio
);
